export const dbFields =
{
    id: {
        visiable: false,
        title: 'Id',
        key: 'id'
    },
    email: {
        visiable: true,
        title: 'Email',
        key: 'email'
    },
    name: {
        visiable: true,
        title: 'Name',
        key: 'name'
    },
    desc: {
        visiable: true,
        title: 'Description',
        key: 'desc'
    },
    passwd: {
        visiable: true,
        title: 'Password',
        key: 'passwd'
    },
    repasswd: {
        visiable: true,
        title: 'Confirm Password',
        key: 'repasswd'
    },
    createdAt: {
        visiable: true,
        title: 'Created',
        key: 'created_at'
    },
    group: {
        visiable: true,
        title: 'Group',
        key: 'group_id'
    },

    groupName: {
        visiable: true,
        title: 'Group',
        key: 'group_name'
    }
};
